<template>
  <div id="reports" class="p-4">
    <div class="card w-100">
      <div class="card-header py-3">
        <div class="row justify-content-between">
          <div class="col-12 col-xl-3">
            <div class="pt-2 font-bold text-uppercase">Assessment History</div>
          </div>
          <div class="col">
            <v-select v-model="filters.station" :options="stationsSelect" :reduce="val => val.code" placeholder="Station" class="v-select_small"/>
          </div>
          <div class="col">
            <v-select v-model="filters.platform" :options="platformsSelect" :reduce="val => val.code" placeholder="Platform" class="v-select_small"/>
          </div>
          <div class="col">
            <v-select v-model="filters.date" :options="dateSelect" :reduce="val => val.code" placeholder="Date" class="v-select_small"/>
          </div>
          <div class="col">
            <v-select v-model="filters.sort" :options="sortSelect" :reduce="val => val.code" placeholder="Sort by" class="v-select_small"/>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name of Assessor</th>
              <th scope="col">Station</th>
              <th scope="col">Platform</th>
              <th scope="col">Date</th>
              <th scope="col"></th>
              <th scope="col" v-if="getAuthUser.role == 'admin'"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="report of getReports" :key="report.id">
              <td class="py-4">{{ report.id }}</td>
              <td class="py-4 position-relative">
                <template v-if="getAuthUser.role === 'admin'">
                  <template v-if="edit_user_report == report.id">
                    <v-select v-model="edit_user_id"
                              :options="getUsersOptions"
                              :clearable="false"
                              :reduce="val => val.id"
                              class="v-select_small"/>
                    <b-icon class="ml-3 mt-2 cursor-pointer position-absolute"
                            style="top: 24px; right: 0;" icon="check-circle" variant="success"
                            @click="onUpdateUser"/>
                  </template>
                  <template v-else-if="report.user !== null">
                    {{ report.user.name }} {{ report.user.surname }}
                    <b-icon class="ml-3 cursor-pointer" icon="pencil-square" variant="success" @click="onShowSelect(report)"/>
                  </template>
                </template>
                <template v-else>
                  {{ report.user.name }} {{ report.user.surname }}
                </template>
              </td>
              <td class="py-4">{{ report.platform.station.name }}</td>
              <td class="py-4">{{ report.platform.name }}</td>
              <td class="py-4">{{ report.created_at }}</td>
              <td class="text-center px-1">
                <router-link :to="'reports/' + report.id">
                  <b-button type="submit" size="sm" variant="outline-secondary" class="mx-auto btn-image btn-link">
                    <img src="../assets/img/report-icon.png"> <span>READ REPORT</span>
                  </b-button>
                </router-link>
              </td>
              <td class="text-center px-1" v-if="getAuthUser.role == 'admin'">
                <b-icon class="h3 cursor-pointer" icon="x" variant="danger" @click="onDelete(report)"/>
              </td>
            </tr>
            <tr>
              <td colspan="7">
                <b-pagination
                    v-model="filters.page"
                    :total-rows="getReportsPagination.total"
                    :per-page="getReportsPagination.per_page"
                    aria-controls="my-table"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'Reports',
    data() {
      return {
        stationSelected: {},
        dateSelect: [
          {label: 'Last week', code: 'week'},
          {label: 'Last month', code: 'month'},
          {label: 'Last 3 months', code: '3months'},
          {label: 'Last 6 months', code: '6months'},
        ],
        sortSelect: [
          {label: 'Name ascending', code: 'name asc'},
          {label: 'Name descending', code: 'name desc'},
          {label: 'Date & Time new first', code: 'date desc'},
          {label: 'Date & Time old first', code: 'date asc'},
        ],
        filters: {
          page: null,
          station: null,
          platform: null,
          date: null,
          sort: null,
          third: null
        },
        edit_user_report: null,
        edit_user_id: null,
      }
    },
    props: {
      third: {
        default: 0
      }
    },
    computed: {
      ...mapGetters([
        'getReports',
        'getReportsPagination',
        'getStations',
        'getUsersOptions',
        'getAuthUser',
      ]),
      stationsSelect() {
        let array = []
        for (let station in this.getStations)
          array.push({label: this.getStations[station].name, code: this.getStations[station].id})
        return array
      },
      platformsSelect() {
        let array = []
        for (let platform in this.stationSelected.platforms)
          array.push({
            label: this.stationSelected.platforms[platform].name,
            code: this.stationSelected.platforms[platform].id
          })
        return array
      },
      reportsData() {
        return this.getReports({ third: this.third });
      },
    },
    mounted() {
      this.filters.page = 1
      this.queryStations()
      console.log("this third" + this.third)
      this.setReportsFilters({ third_party: this.third });
      if (this.getAuthUser.role === 'admin')
        this.queryUsers()
    },
    watch: {
      third(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setReportsFilters({ third_party: newVal });
          this.queryReports();
        }
      },
      'filters.page'(val) {
        this.setReportsFilters(this.filters)
        this.queryReports()
      },
      'filters.platform'(val) {
        this.filters.platform = val
        this.setReportsFilters(this.filters)
        this.queryReports()
      },
      'filters.station'(val) {
        this.filters.station = val
        this.filters.platform = null
        for (let station in this.getStations)
          if (this.getStations[station].id == val)
            this.stationSelected = this.getStations[station]
        this.setReportsFilters(this.filters)
        this.queryReports()
      },
      'filters.date'(val) {
        this.filters.date = val
        this.setReportsFilters(this.filters)
        this.queryReports()
      },
      'filters.sort'(val) {
        this.filters.sort = val
        this.setReportsFilters(this.filters)
        this.queryReports()
      }
    },
    methods: {
      ...mapActions([
        'queryReports',
        'queryStations',
        'queryUsers',
        'updateReport',
        'destroyReport',
      ]),
      ...mapMutations([
        'setReportsFilters'
      ]),
      onShowSelect(report) {
        this.edit_user_report = report.id
        this.edit_user_id = parseInt(report.user_id)
      },
      onUpdateUser() {
        if (this.edit_user_report && this.edit_user_id) {
          this.updateReport([this.edit_user_report, {user_id: this.edit_user_id}])
          this.edit_user_report = null
          this.edit_user_id = null
        }
      },
      onDelete(report) {
        this.$bvModal.msgBoxConfirm('Delete report ' + report.id + '?', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value)
            this.destroyReport(report.id)
        })
      }
    }
  }
</script>

<style lang="scss">

</style>